module.exports = __webpack_public_path__ + "img/img-placeholder.d1a9a154.jpg";